
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component
export default class SepllRow extends Vue {
  @Prop() organizer: any
  @Prop() type: any
  timeText: any = '00:00:00'
  setTimeoutId: any = null
  mounted() {
    let ms =
      Date.newDate(this.organizer.end_time).getTime() - new Date().getTime()
    this.countdown(ms)
  }
  countdown(msec) {
    // 相差的毫秒数
    if (msec <= 0) {
      return window.clearTimeout(this.setTimeoutId)
    }
    this.timeText = Date.formatMs(
      msec,
      msec / (24 * 60 * 60 * 1000) > 1 ? 'DD天 hh:mm:ss' : 'hh:mm:ss'
    )
    // 一秒后递归
    this.setTimeoutId = setTimeout(() => {
      this.countdown(msec - 1000)
    }, 1000)
  }
  beforeDestory() {
    window.clearTimeout(this.setTimeoutId)
  }
  // todo
  organizerDetail() {
    let { spuId } = this.$route.query
    this.$router.push({
      path: `/groupView`,
      query: {
        orgId: this.organizer.id,
        spuId,
        type: this.type,
      },
    })
  }
}
